import Quote from 'i18n/default/es/Quote';
import Summary from 'i18n/default/es/Summary';
import Login from 'i18n/default/es/Login';
import OrdersOrderDetail from 'i18n/default/es/OrdersOrderDetail';
import Settings from 'i18n/default/es/Settings';
import PaymentData from 'i18n/default/es/PaymentData';
import Faqs from 'i18n/default/es/Faqs';
import Communications from 'i18n/default/es/Communications';
import Error from 'i18n/default/es/Error';
import Catalog from 'i18n/default/es/Catalog';

const lang = {
  Catalog,
  Communications,
  Error,
  Faqs,
  Login,
  OrdersOrderDetail,
  PaymentData,
  Quote,
  Settings,
  Summary,
};

export default lang;
